export const INTENT_TYPES = {
  DIRECT_ANSWER_REQUEST: 'direct_answer_request',
  EXPLANATION_REQUEST: 'explanation_request',
  OFF_TOPIC: 'off_topic',
  OFF_TOPIC_ACADEMIC: 'off_topic_academic',
  HELP_REQUEST: 'help_request',
  VERIFICATION: 'verification',
  CURIOUS_EXPLORATION: 'curious_exploration',
  COMPLAINT: 'complaint',
  INADEQUATE: 'inadequate',
  UNCLASSIFIED: 'unclassified',
  CONVERSATIONAL: 'conversational',
} as const;

export type IntentType = (typeof INTENT_TYPES)[keyof typeof INTENT_TYPES];

export const INTENT_COLOR_INDEX: Record<IntentType, number> = {
  [INTENT_TYPES.OFF_TOPIC]: 2,
  [INTENT_TYPES.OFF_TOPIC_ACADEMIC]: 2,
  [INTENT_TYPES.EXPLANATION_REQUEST]: 3,
  [INTENT_TYPES.COMPLAINT]: 4,
  [INTENT_TYPES.HELP_REQUEST]: 5,
  [INTENT_TYPES.CURIOUS_EXPLORATION]: 6,
  [INTENT_TYPES.DIRECT_ANSWER_REQUEST]: 7,
  [INTENT_TYPES.INADEQUATE]: 8,
  [INTENT_TYPES.VERIFICATION]: 1,
  [INTENT_TYPES.UNCLASSIFIED]: 1,
  [INTENT_TYPES.CONVERSATIONAL]: 1,
};

export const INTENT_LABEL_KEYS: Record<string, string> = {
  [INTENT_TYPES.DIRECT_ANSWER_REQUEST]: 'ai_analytics_intent_direct_answer_request',
  [INTENT_TYPES.EXPLANATION_REQUEST]: 'ai_analytics_intent_explanation_request',
  [INTENT_TYPES.OFF_TOPIC]: 'ai_analytics_intent_off_topic',
  [INTENT_TYPES.OFF_TOPIC_ACADEMIC]: 'ai_analytics_intent_off_topic_academic',
  [INTENT_TYPES.HELP_REQUEST]: 'ai_analytics_intent_help_request',
  [INTENT_TYPES.VERIFICATION]: 'ai_analytics_intent_verification',
  [INTENT_TYPES.CURIOUS_EXPLORATION]: 'ai_analytics_intent_curious_exploration',
  [INTENT_TYPES.COMPLAINT]: 'ai_analytics_intent_complaint',
  [INTENT_TYPES.INADEQUATE]: 'ai_analytics_intent_inadequate',
  [INTENT_TYPES.UNCLASSIFIED]: 'ai_analytics_intent_unclassified',
  [INTENT_TYPES.CONVERSATIONAL]: 'ai_analytics_intent_conversational',
};
